import { render, staticRenderFns } from "./CrudCompany.vue?vue&type=template&id=18b1b600&scoped=true&"
import script from "./CrudCompany.vue?vue&type=script&lang=js&"
export * from "./CrudCompany.vue?vue&type=script&lang=js&"
import style0 from "./CrudCompany.vue?vue&type=style&index=0&id=18b1b600&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1b600",
  null
  
)

export default component.exports